$('.click--down').click(function() {
    if ($(this).hasClass('down')) {
        $(this).parent().find('.accordion--slide').slideDown();
        $(this).addClass('up').removeClass('down');
    } else {
        $(this).parent().find('.accordion--slide').slideUp();
        $(this).addClass('down').removeClass('up');
    }
});
